import { render, staticRenderFns } from "./VNOrder.vue?vue&type=template&id=0553b962&scoped=true"
import script from "./VNOrder.vue?vue&type=script&lang=ts"
export * from "./VNOrder.vue?vue&type=script&lang=ts"
import style0 from "./VNOrder.vue?vue&type=style&index=0&id=0553b962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553b962",
  null
  
)

export default component.exports